export default __webpack_public_path__ + "static/media/PersonalPortfolio.16621080.png";